import {
  ActionIcon,
  Alert,
  Box,
  Button,
  Card,
  Center,
  Checkbox,
  Divider,
  Fieldset,
  Flex,
  Grid,
  Group,
  LoadingOverlay,
  Modal,
  Paper,
  Radio,
  ScrollArea,
  Select,
  Text,
  Textarea,
  TextInput,
  Title,
} from "@mantine/core";
import { DateInput, DatePickerInput, DateTimePicker } from "@mantine/dates";
import { hasLength, useForm } from "@mantine/form";
import {
  IconCalendarDue,
  IconLock,
  IconChecks,
  IconSearch,
  IconSend,
  IconTimeDuration15,
  IconTrash,
  IconX,
} from "@tabler/icons-react";
import React, { useEffect, useState } from "react";
import className from "../CreateProfile.module.scss";
import { ReactComponent as UploadIcon } from "../../../../assets/icon/upload.svg";
import { ReactComponent as UploadIconPlus } from "../../../../assets/icon/upload_plus.svg";
import { useDisclosure } from "@mantine/hooks";
import { repositorySign } from "../../../../_base/_const/_constVar";
import { MessageResponse } from "../../../../model/MessageResponse";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import FileUpload from "../UploadFile/UploadFile";
import { modals } from "@mantine/modals";
import { notifications } from "@mantine/notifications";
import {
  SelectListItem,
  SelectListItemBase,
} from "../../../../_base/model/_base/SelectListItemBase";
import { TblDocumentCommand } from "../../../../model/TblDocumentCommand";
import {
  DOCUMENT_FILES_LOCKED_MESSAGE,
  DOCUMENT_FILES_LOCKED_REASON,
} from "../../../../const/documentLock";
import { Dropzone, MIME_TYPES } from "@mantine/dropzone";
import {
  getFileNames,
  uploadFile,
  UploadFileResult,
} from "../../../../_base/extension/Extension";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getDepartmentSelect,
  getUsersSelect,
} from "../../../../const/getSelectApi";
import dayjs from "dayjs";
import { formatToVietnamTz } from "../../../../_base/extension/DateExtension";
import { EcmNodeContent } from "../../../../model/EcmNodeContent";

interface UploadedFile {
  bucket: string;
  endPoint: string;
  etag: string;
  objectName: string;
  pathNameBefore: string;
  size: number;
  url: string;
}

const options = [
  { label: "1 Tuần", value: "1" },
  { label: "2 Tuần", value: "2" },
  { label: "3 Tuần", value: "3" },
  { label: "4 Tuần", value: "4" },
];

export const EditProfile = ({ id, onClose }: DocTypeEditViewProps) => {
  const navigate = useNavigate();
  const localtion = useLocation();
  const [height, setHeight] = useState(0);
  const idDetail = localtion.state && localtion.state.id;
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [listEmployee, setListEmployee] = useState<SelectListItem[]>([]);
  const [listDocument, setListDocument] = useState<SelectListItem[]>([]);
  const [listDepartment, setListDepartment] = useState<SelectListItem[]>([]);
  const [uploadedUrls, setUploadedUrls] = useState<string[]>(() => []);
  const [listDocType, setListDocType] = useState<SelectListItemBase[]>([]);
  const [listVendor, setListVendor] = useState<SelectListItem[]>([]);
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [visibleHandelLoad, setVisibleHandelLoad] = useState(false);
  // const [handleDoctypeId, setHandleDoctypeId] = useState<string | null>("");
  // const [listDataDoctypeCreate, setListDataDoctypeCreate] =
  //   useState<TblDocumentCommand>();
  const [generateDocumentCode, setGenerateDocumentCode] = useState<string>("");
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const [uploadedFiles1, setUploadedFiles1] = useState<UploadedFile[]>([]);
  const [uploadedFiles2, setUploadedFiles2] = useState<UploadedFile[]>([]);
  const [checkedValue, setCheckedValue] = useState<number | null>(null);
  const [listUploadedFiles, setListUploadedFiles] = useState<
    UploadFileResult[]
  >([]);
  const [fileNameDownloadV2, setFileNameDownloadV2] = useState<
    EcmNodeContent[]
  >([]);
  const entity: TblDocumentCommand = {
    id: 0,
    code: "",
    name: "",
    doctypeId: 0,
    relateRecordsId: "",
    description: "",
    employeeId: 0,
    signedDocument: "",
    attachments: "",
  };

  const form = useForm<TblDocumentCommand>({
    mode: "controlled",
    validateInputOnChange: false,
    initialValues: entity,
    validate: {
      name: (value) => {
        if (!value) {
          return "Vui lòng nhập tên hồ sơ!";
        }
        return hasLength(
          { min: 5, max: 150 },
          "Tên phải từ 5-150 kí tự!"
        )(value as string);
      },

      doctypeId: (value) => {
        if (!value) {
          return "Vui lòng chọn loại hồ sơ!";
        }
      },
      code: (value) => {
        if (!value) {
          return "Vui lòng chọn mã hồ sơ!";
        }
      },
      employeeId: (value) => {
        if (!value) {
          return "Vui lòng nhân viên trình ký!";
        }
      },
      // relateRecordsId: (value) => {
      //   if (!value) {
      //     return "Vui lòng chọn hồ sơ liên quan ký!";
      //   }
      // },
      // departmentId: (value) => {
      //   if (!value) {
      //     return "Vui lòng chọn đơn vị trình ký!";
      //   }
      // },
      // partnerId: (value) => {
      //   if (!value) {
      //     return "Vui lòng chọn đối tác!";
      //   }
      // },
    },
  });

  const handleFilesUploaded1 = (uploadedFiles: UploadedFile[]) => {
    setUploadedFiles1(uploadedFiles);
  };

  const handleFilesUploaded2 = (uploadedFiles: UploadedFile[]) => {
    setUploadedFiles2(uploadedFiles);
  };

  //hàm check checbox theo value
  // const handleCheckboxChange = (value: number) => {
  //   setCheckedValue((prev) => (prev === value ? null : value));
  //   form.setFieldValue("warningExpired", checkedValue);
  // };

  //Hàm chọn ngày bắt đầu và ngày kêt thúc
  // const handleRangeChange = (dates: [Date | null, Date | null]) => {
  //   const [startDate, endDate] = dates;
  //   form.setFieldValue("startDate", startDate ? startDate.toISOString() : null);
  //   form.setFieldValue(
  //     "expirationDate",
  //     endDate ? endDate.toISOString() : null
  //   );
  // };

  // const ModalChildRen = () => (
  //   <Modal
  //     opened={isModalOpen}
  //     onClose={() => setModalOpen(false)}
  //     title={<Title order={4}>Upload tài liệu ký</Title>}
  //     centered
  //     size="40%"
  //     overlayProps={{
  //       backgroundOpacity: 0.55,
  //       blur: 3,
  //     }}
  //     zIndex={99999}
  //   >
  //     <Divider mt={0} my="md" />
  //     <Text>Bạn có thể chọn tệp tin từ đây</Text>
  //   </Modal>
  // );

  const handleCreateTblDocumentMethod = async (
    dataSubmit: TblDocumentCommand
  ) => {
    open();
    let isValid = true;
    if (!form.getValues().signedDocument && !form.getValues().attachments) {
      isValid = false;
    }

    if (!isValid) {
      NotificationExtension.Fails("Vui lòng chọn file để trình ký!");
      // setDisabled(false);
      close();
      return;
    }

    const dataApiS = {
      ...dataSubmit,
      createDate: formatToVietnamTz(dataSubmit.createDate),
      signedDate: formatToVietnamTz(dataSubmit.signedDate),
      expirationDate: formatToVietnamTz(dataSubmit.expirationDate),
      startDate: formatToVietnamTz(dataSubmit.startDate),
    };

    const dataApi = await repositorySign.post<
      MessageResponse<TblDocumentCommand>
    >("/api/v1/TblDocument/update", dataApiS);
    if (dataApi?.success) {
      // onClose((prev: any) => !prev);
      NotificationExtension.Success("Thành công !");
      setTimeout(() => {
        navigate("/method/folders-task");
      }, 1000);
      // modals.closeAll();
    } else {
      NotificationExtension.Fails(dataApi?.message || "Có lỗi xảy ra!");
    }
    close();
  };

  //API get list thêm hồ sơ
  const handleGetDataDocType = async () => {
    setVisibleHandelLoad(true);
    let url = `/api/v1/TblDocument/update?id=${idDetail}`;
    const response = await repositorySign.get<
      MessageResponse<TblDocumentCommand>
    >(url);

    if (!response?.success) {
      NotificationExtension.Fails("Bạn không có quyền sửa!");
      modals.closeAll();
      return;
    }

    setTimeout(() => {
      setVisibleHandelLoad(false);
    }, 300);

    if (response.success) {
      const dataVendor = response?.data;
      if (dataVendor != null) {
        const result = response.data;
        form.setValues(dataVendor);
        form.resetDirty(dataVendor);
        form.initialize(result);
        // if (result.expirationDate) {
        //   console.log(new Date(result.expirationDate));
        //   console.log(result.expirationDate);
        //   const localDate = dayjs(result.expirationDate).format("YYYY-MM-DD HH:mm:ss");
        //   console.log("Local date:", localDate);
        // }
        if (result.createDate)
          form.setFieldValue("createDate", new Date(result.createDate));
        if (result.expirationDate)
          form.setFieldValue("expirationDate", new Date(result.expirationDate));
        if (result.startDate)
          form.setFieldValue("startDate", new Date(result.startDate));
        if (result.signedDate)
          form.setFieldValue("signedDate", new Date(result.signedDate));
        if (result.employeeId)
          form.setFieldValue("employeeId", result.employeeId.toString());
        if (result.doctypeId)
          form.setFieldValue("doctypeId", result.doctypeId.toString());
        if (result.departmentId)
          form.setFieldValue("departmentId", result.departmentId.toString());
        if (result.partnerId)
          form.setFieldValue("partnerId", result.partnerId.toString());
        if (result.signedDocument)
          form.setFieldValue(
            "signedDocument",
            result.signedDocument.toString()
          );
        if (result.attachments)
          form.setFieldValue("attachments", result.attachments.toString());

        if (response.data.signedDocument) {
          const urls = response.data.signedDocument.split("||");
          const getUserName = await getFileNames(urls);
          if (getUserName && getUserName.length > 0) {
            setFileNameDownloadV2((prev) => [...prev, ...getUserName]);
          }
        }
        if (response.data.attachments) {
          const urls = response.data.attachments.split("||");
          const getUserName = await getFileNames(urls);
          if (getUserName && getUserName.length > 0) {
            setFileNameDownloadV2((prev) => [...prev, ...getUserName]);
          }
        }
      }
      close();
    } else {
      modals.closeAll();
    }
  };

  //API gọi danh sách nhân viên
  const fetchDataEmployee = async () => {
    const response = await getUsersSelect();

    if (response) {
      setListEmployee(response);
    }
  };

  //API gọi danh sách phòng ban
  const fetchDataDepartment = async () => {
    const response = await getDepartmentSelect();

    if (response) {
      setListDepartment(response);
    }
  };

  //API gọi danh sách hồ sơ liên quan
  const fetchDataDocument = async () => {
    const response = await repositorySign.get<
      MessageResponse<SelectListItem[]>
    >("/api/v1/TblDocument/get-select-relation-document");

    if (response && response.success) {
      let result = response.data;
      setListDocument(result);
    }
  };

  //API gọi danh sách loại hồ sơ
  const fetchDataDocType = async () => {
    const response = await repositorySign.get<
      MessageResponse<SelectListItemBase[]>
    >("/api/v1/TblDocType/get-select");

    if (response && response.success) {
      let result = response.data;
      setListDocType(result);
    }
  };

  //API mã hồ sơ
  const fetchDataGenerateDocumentCode = async () => {
    const type = form.getValues().doctypeId;
    if (type) {
      const response = await repositorySign.get<MessageResponse<string>>(
        `/api/v1/TblDocument/generate-document-code?doctypeId=${type}`
      );
      if (response && response.success) {
        const result = response.data;
        if (result) form.setFieldValue("code", result);
      }
    }
  };

  //API gọi danh sách đối tác
  const fetchDataVendor = async () => {
    const response = await repositorySign.get<
      MessageResponse<SelectListItem[]>
    >("/api/v1/TblVendor/get-select");

    if (response && response.success) {
      let result = response.data;
      setListVendor(result);
    }
  };

  useEffect(() => {
    handleGetDataDocType();
  }, [idDetail]);

  useEffect(() => {
    fetchDataEmployee();
    fetchDataDepartment();
    fetchDataDocument();
    fetchDataDocType();
    fetchDataVendor();
    // fetchDataGenerateDocumentCode();
  }, []);

  useEffect(() => {
    const updateFieldValue = (
      files: UploadedFile[] | null,
      fieldName: string
    ) => {
      if (files) {
        const urls = files
          .map((file) => file.url)
          .join("||")
          .trim();
        form.setFieldValue(fieldName, urls);
      }
    };

    updateFieldValue(uploadedFiles1, "signedDocument");
    updateFieldValue(uploadedFiles2, "attachments");
  }, [uploadedFiles1, uploadedFiles2]);

  //Lấy chiều cao mặc định khi header thay đổi
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (160 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  //#region Upload FIle

  const handleUploadFiles = async (files: File[]) => {
    const formData = new FormData();
    files.forEach((file) => formData.append("files", file));
    try {
      const response = await repositorySign.post<MessageResponse<any>>(
        "/api/v1/Upload/files",
        formData
      );

      if (response?.success === true) {
        NotificationExtension.Success("Thêm tệp tin thành công");
        handleFilesUploaded1(response.data);
      } else {
        NotificationExtension.Fails("Thêm tệp tin thất bại");
      }
    } catch (error) {
      console.error("Error uploading files:", error);
    }
  };

  const handleDrop = async (acceptedFiles: File[]) => {
    if (acceptedFiles.length > 0) await handleUploadFiles(acceptedFiles);
    else NotificationExtension.Info("Vui lòng chọn tập tin !");
  };

  const handleRemoveFile = (index: number) => {
    //setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  useEffect(() => {
    if (form.getValues().signedDocument) {
      const data = form.getValues().signedDocument;
      const urls = data.split("||");
      setUploadedUrls(urls);
    }
  }, [form.getValues().signedDocument]);

  //#endregion
  const filesLocked = form.getValues().issign === true;
  return (
    <>
      {/* {ModalChildRen()} */}
      <LoadingOverlay
        visible={visibleHandelLoad}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 2 }}
      />

      <Box
        onSubmit={form.onSubmit((e: TblDocumentCommand) => {
          handleCreateTblDocumentMethod(e);
        })}
        style={{ position: "relative" }}
        component="form"
      >
        <Group justify="space-between" p="0 0 10px" ref={headerRef}>
          <Title order={4}>Chỉnh sửa hồ sơ</Title>
          <Flex gap={20}>
            <Button
              leftSection={<IconSend size={14} />}
              variant="outline"
              radius="xl"
              color="green"
              type="submit"
              // disabled={form.getValues().issign === true}
            >
              Lưu và gửi duyệt
            </Button>
            {/* <Button
              leftSection={<IconChecks size={14} />}
              radius="xl"
              color="orange"
              variant="outline"
            >
              Lưu và đóng
            </Button> */}
          </Flex>
        </Group>
        <Grid gutter="xs">
          <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
            <Card
              shadow="sm"
              radius="md"
              withBorder
              p="lg"
              pr={0}
              pt={15}
              style={{
                boxShadow: "0 1px 10px rgba(0, 0, 0, 0.1)",
                maxHeight: height + 55,
                minHeight: height + 55,
              }}
            >
              <ScrollArea w="100%" pr={5} h={height + 600} offsetScrollbars>
                <Grid>
                  <Grid.Col span={{ base: 12 }}>
                    <Select
                      key={form.key("doctypeId")}
                      label="Loại hồ sơ:"
                      placeholder="Vui lòng chọn hồ sơ"
                      nothingFoundMessage="Không có dữ liệu"
                      data={listDocType.map((doctype) => ({
                        value: doctype.value,
                        label: doctype.text,
                      }))}
                      limit={20}
                      searchable
                      withAsterisk
                      //   onClick={async () => await fetchDataDocType()}
                      {...form.getInputProps("doctypeId")}
                      onChange={(value) => {
                        form.setFieldValue("doctypeId", value ?? "");
                        if (value) {
                          const code = listDocType.find(
                            (x) => x.value == value
                          )?.att1;
                          form.setFieldValue(
                            "code",
                            code?.toUpperCase() +
                              form.getValues().code.slice(-5)
                          );
                        }
                      }}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12 }}>
                    <TextInput
                      flex={1}
                      key={form.key("name")}
                      label="Tên hồ sơ"
                      placeholder={"Vui lòng chọn tên hồ sơ"}
                      withAsterisk
                      {...form.getInputProps("name")}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                    <TextInput
                      key={form.key("code")}
                      readOnly
                      flex={1}
                      label="Mã hồ sơ:"
                      placeholder={"Vui lòng chọn mã hồ sơ"}
                      withAsterisk
                      {...form.getInputProps("code")}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                    <Select
                      key={form.key("employeeId")}
                      label="Nhân viên trình ký:"
                      placeholder="Vui lòng chọn nhân viên"
                      nothingFoundMessage="Không có dữ liệu"
                      data={listEmployee.map((employee) => ({
                        value: employee.value,
                        label: employee.text,
                      }))}
                      limit={20}
                      // onClick={async () => await fetchDataEmployee()}
                      //  defaultValue={form.getValues().employeeId}
                      searchable
                      withAsterisk
                      {...form.getInputProps("employeeId")}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12 }}>
                    <Textarea
                      rows={9}
                      key={form.key("description")}
                      label="Mô tả:"
                      placeholder="Nhập Mô tả"
                      {...form.getInputProps("description")}
                    />
                  </Grid.Col>
                </Grid>

                {filesLocked && (
                  <Alert
                    color="orange"
                    variant="light"
                    icon={<IconLock size={18} />}
                    title={DOCUMENT_FILES_LOCKED_MESSAGE}
                    mb="xs"
                  >
                    {DOCUMENT_FILES_LOCKED_REASON}
                  </Alert>
                )}
                <Box className={className.DragAndDrop_content}>
                  <Fieldset
                    style={{ display: "flex", justifyContent: "center" }}
                    legend="Tài liệu ký"
                    p={10}
                  >
                    <Flex
                      className={className.style_container}
                      align="center"
                      justify="center"
                      direction="column"
                    >
                      <Box className={className.Box_animation_left}>
                        <Dropzone
                          disabled={filesLocked}
                          onDrop={async (acceptedFiles) => {
                            if (acceptedFiles.length > 0) {
                              const res = await uploadFile(acceptedFiles);
                              if (res && res.length > 0)
                                setListUploadedFiles((prev) => [
                                  ...prev,
                                  ...res,
                                ]);
                              res?.forEach((element) => {
                                const value = form.getValues().signedDocument;
                                if (!value || value.length < 1) {
                                  form.setFieldValue(
                                    "signedDocument",
                                    element.url
                                  );
                                } else
                                  form.setFieldValue(
                                    "signedDocument",
                                    value + "||" + element.url
                                  );
                              });
                            } else
                              NotificationExtension.Info(
                                "Vui lòng chọn tập tin !"
                              );
                          }}
                          accept={[MIME_TYPES.pdf]}
                          multiple
                        >
                          <Box className="DragAndDrop_children">
                            <Center>
                              <UploadIcon width={70} height={70} />
                            </Center>
                            <Flex align="center" justify="center" gap={5}>
                              <Text size="sm">Kéo thả File của bạn</Text>
                              <Text td="underline" fw={600} c="blue" size="sm">
                                hoặc chọn tệp tin
                              </Text>
                            </Flex>
                          </Box>
                        </Dropzone>
                      </Box>
                      <Box className={className.Box_animation_right} mt={16}>
                        <Flex
                          align="center"
                          justify="center"
                          direction="column"
                        >
                          {form.getValues().signedDocument.length > 0 ? (
                            form
                              .getValues()
                              .signedDocument.split("||")
                              .filter((x) => x && x.length > 0)
                              .map((url, index) => (
                                <Group key={index} mt="sm">
                                  <Text size="sm">
                                    {listUploadedFiles.find(
                                      (file) => file.url === url
                                    )?.fileNameBeforeUpdate ??
                                      fileNameDownloadV2.find(
                                        (x) =>
                                          x.fileName === url.split("/").pop()
                                      )?.originName ??
                                      url.split("/").pop()}
                                  </Text>
                                  <Button
                                    leftSection={<IconTrash size={14} />}
                                    disabled={filesLocked}
                                    color="red"
                                    size="xs"
                                    variant="light"
                                    onClick={() => {
                                      if (url) {
                                        const updatedAttachments = form
                                          .getValues()
                                          .signedDocument.split("||")
                                          .filter(
                                            (item) =>
                                              item !== url && item.length > 0
                                          )
                                          .join("||");
                                        form.setFieldValue(
                                          "signedDocument",
                                          updatedAttachments
                                        );
                                      }
                                    }}
                                  >
                                    Xoá
                                  </Button>
                                </Group>
                              ))
                          ) : (
                            <Text size="sm" c="gray">
                              Không có tệp tin nào được đính kèm
                            </Text>
                          )}
                        </Flex>
                      </Box>
                    </Flex>
                  </Fieldset>
                </Box>
              </ScrollArea>
            </Card>
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
            <Card
              shadow="sm"
              radius="md"
              withBorder
              p="lg"
              pr={0}
              pt={15}
              style={{
                boxShadow: "0 1px 10px rgba(0, 0, 0, 0.1)",
                maxHeight: height + 55,
                minHeight: height + 55,
              }}
            >
              <ScrollArea w="100%" pr={5} h={height + 600} offsetScrollbars>
                <Grid>
                  <Grid.Col span={{ base: 12 }}>
                    <Select
                      key={form.key("relateRecordsId")}
                      flex={1}
                      label="Hồ sơ liên quan:"
                      placeholder="Vui lòng chọn hồ sơ liên quan"
                      nothingFoundMessage="Không có dữ liệu"
                      data={listDocument.map((employee) => ({
                        value: employee.value,
                        label: employee.text,
                      }))}
                      limit={20}
                      searchable
                      // withAsterisk
                      //   onClick={async () => await fetchDataDocument()}
                      {...form.getInputProps("relateRecordsId")}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12 }}>
                    <Select
                      key={form.key("departmentId")}
                      readOnly
                      label="Đơn vị trình ký:"
                      placeholder="Vui lòng chọn đơn vị trình ký"
                      nothingFoundMessage="Không có dữ liệu"
                      data={listDepartment.map((employee) => ({
                        value: employee.value,
                        label: employee.text,
                      }))}
                      limit={1}
                      searchable
                      //  withAsterisk
                      //  onClick={async () => await fetchDataDepartment()}
                      {...form.getInputProps("departmentId")}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12 }}>
                    <Select
                      key={form.key("parentId")}
                      flex={1}
                      label="Đối tác:"
                      placeholder="Vui lòng chọn đối tác"
                      nothingFoundMessage="Không có dữ liệu"
                      data={listVendor.map((employee) => ({
                        value: employee.value,
                        label: employee.text,
                      }))}
                      limit={20}
                      //   onClick={async () => await fetchDataVendor()}
                      searchable
                      //   withAsterisk
                      {...form.getInputProps("partnerId")}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 6 }}>
                    {" "}
                    <DateInput
                      key={form.key("createDate")}
                      label="Ngày tạo:"
                      readOnly
                      valueFormat="DD/MM/YYYY"
                      //  rightSection={<IconCalendarDue color="black" />}
                      clearable
                      placeholder="Vui lòng chọn ngày tạo"
                      {...form.getInputProps("createDate")}
                    />
                  </Grid.Col>{" "}
                  <Grid.Col span={{ base: 6 }}>
                    {" "}
                    <DateInput
                      key={form.key("signedDate")}
                      label="Ngày ký:"
                      minDate={form.values.createDate}
                      valueFormat="DD/MM/YYYY"
                      clearable
                      placeholder="Vui lòng chọn ngày ký"
                      {...form.getInputProps("signedDate")}
                    />
                  </Grid.Col>{" "}
                  <Grid.Col span={{ base: 6 }}>
                    <DatePickerInput
                      key={form.key("startDate")}
                      label="Hiệu lực từ:"
                      minDate={form.values.createDate}
                      placeholder="Chọn ngày"
                      valueFormat="DD/MM/YYYY"
                      clearable
                      {...form.getInputProps("startDate")}
                    />
                  </Grid.Col>{" "}
                  <Grid.Col span={{ base: 6 }}>
                    <DatePickerInput
                      key={form.key("expirationDate")}
                      label="Có hiệu lực đến:"
                      minDate={form.values.createDate}
                      placeholder="Chọn ngày"
                      clearable
                      valueFormat="DD/MM/YYYY"
                      {...form.getInputProps("expirationDate")}
                    />
                  </Grid.Col>{" "}
                  <Grid.Col span={{ base: 12 }}>
                    <Checkbox.Group
                      label="Cảnh báo hết hiệu lực:"
                      description=""
                    >
                      <Group mt="xs">
                        {options.map((option: any) => (
                          <Checkbox
                            key={option.value}
                            // checked={checkedValue === option.value}
                            //  onChange={() => handleCheckboxChange(option.value)}
                            // color="lime.4"
                            // iconColor="dark.8"
                            size="md"
                            label={option.label}
                            value={option.value}
                          />
                        ))}
                      </Group>
                    </Checkbox.Group>
                  </Grid.Col>{" "}
                  <Grid.Col span={{ base: 12 }}></Grid.Col>
                </Grid>

                {/* <Group mb={25} align="center" justify="space-between">
                  <Text style={{ flex: "0 0 160px", whiteSpace: "nowrap" }}>
                    Cảnh báo hết hiệu lực:
                  </Text>
                  <Flex gap={25}>
                    {options.map((option: any) => (
                      <Checkbox
                        key={option.value}
                        checked={checkedValue === option.value}
                        onChange={() => handleCheckboxChange(option.value)}
                        color="lime.4"
                        iconColor="dark.8"
                        size="md"
                        label={option.label}
                      />
                    ))}
                  </Flex>
                </Group> */}
                <Box mt={"xs"} className={className.DragAndDrop_content}>
                  <Fieldset
                    style={{ display: "flex", justifyContent: "center" }}
                    legend="Tài liệu đính kèm"
                    p={10}
                  >
                    <Flex
                      className={className.style_container}
                      align="center"
                      justify="center"
                      direction="column"
                    >
                      <Box className={className.Box_animation_left}>
                        <Dropzone
                          disabled={filesLocked}
                          onDrop={async (acceptedFiles) => {
                            if (acceptedFiles.length > 0) {
                              const res = await uploadFile(acceptedFiles);
                              if (res && res.length > 0)
                                setListUploadedFiles((prev) => [
                                  ...prev,
                                  ...res,
                                ]);
                              res?.forEach((element) => {
                                const value = form.getValues().attachments;
                                if (!value || value.length < 1) {
                                  form.setFieldValue(
                                    "attachments",
                                    element.url
                                  );
                                } else
                                  form.setFieldValue(
                                    "attachments",
                                    value + "||" + element.url
                                  );
                              });
                            } else
                              NotificationExtension.Info(
                                "Vui lòng chọn tập tin !"
                              );
                          }}
                          accept={[MIME_TYPES.pdf]}
                          multiple
                        >
                          <Box className="DragAndDrop_children">
                            <Center>
                              <UploadIconPlus width={70} height={70} />
                            </Center>
                            <Flex align="center" justify="center" gap={5}>
                              <Text size="sm">Kéo thả File của bạn</Text>
                              <Text td="underline" fw={600} c="blue" size="sm">
                                hoặc chọn tệp tin
                              </Text>
                            </Flex>
                          </Box>
                        </Dropzone>
                      </Box>
                      <Box className={className.Box_animation_right} mt={16}>
                        <Flex
                          align="center"
                          justify="center"
                          direction="column"
                        >
                          {form.getValues().attachments?.length > 0 ? (
                            form
                              .getValues()
                              .attachments.split("||")
                              .filter((x) => x && x.length > 0)
                              .map((url, index) => (
                                <Group key={index} mt="sm">
                                  <Text size="sm">
                                    {listUploadedFiles.find(
                                      (file) => file.url === url
                                    )?.fileNameBeforeUpdate ??
                                      fileNameDownloadV2.find(
                                        (x) =>
                                          x.fileName === url.split("/").pop()
                                      )?.originName ??
                                      url.split("/").pop()}
                                  </Text>
                                  <Button
                                    leftSection={<IconTrash size={14} />}
                                    disabled={filesLocked}
                                    color="red"
                                    size="xs"
                                    variant="light"
                                    onClick={() => {
                                      if (url) {
                                        const updatedAttachments = form
                                          .getValues()
                                          .attachments.split("||")
                                          .filter(
                                            (item) =>
                                              item !== url && item.length > 0
                                          )
                                          .join("||");
                                        form.setFieldValue(
                                          "attachments",
                                          updatedAttachments
                                        );
                                      }
                                    }}
                                  >
                                    Xoá
                                  </Button>
                                </Group>
                              ))
                          ) : (
                            <Text size="sm" c="gray">
                              Không có tệp tin nào được đính kèm
                            </Text>
                          )}
                        </Flex>
                      </Box>
                    </Flex>
                  </Fieldset>
                </Box>
              </ScrollArea>
            </Card>
          </Grid.Col>
        </Grid>
      </Box>
    </>
  );
};

type DocTypeEditViewProps = {
  id?: number | string;
  onClose?: any;
};
